export default "__VITE_ASSET__CGHc9Cug__"